import React from 'react';
import { blogProps, useAuth, useInfo } from '../../context';
import { useAlert, useFetch } from '../../hooks';
import {
    Form,
    Field,
    InputEventProps,
    FormType,
    ActionButton,
    Alert
} from '..';

const blogInitialState: blogProps = {
    Title: '',
    DatePosted: new Date(),
    Description: '',
    CoverImage: '',
    Link: ''
};
export const AddBlogForm: React.FC = React.memo(() => {
    const { session } = useAuth();
    const { dispatchInfo } = useInfo();
    const { alert, dispatchAlert, closeAlert } = useAlert();
    // const [selectedFiles, setSelectedFiles] = React.useState<Array<string | any>>(
    //     []
    // );
    // const [selectedFilePreviews, setSelectedFilePreviews] = React.useState<
    //     Array<string | any>
    // >([]);
    // const [error, setError] = React.useState<string | null>(null);
    // const [totalSize, setTotalSize] = React.useState(0);
    const [fetchHandler, loading] = useFetch('/dbAddBlogs', 'POST');
    const [blog, setBlog] = React.useState<blogProps>(blogInitialState);

    const onChangeHandler = React.useCallback(
        (key: keyof blogProps) => (e: InputEventProps) =>
            setBlog(prevBlog => {
                return {
                    ...prevBlog,
                    [key]: e.target.value
                };
            }),
        []
    );

    const errorHandler = React.useCallback(
        message => {
            dispatchAlert({
                type: 'UPDATE_ALERT',
                message: message,
                severity: 'error'
            });
            setBlog(blogInitialState);
        },
        [dispatchAlert]
    );

    const successHandler = React.useCallback(
        blog => {
            dispatchAlert({
                type: 'UPDATE_ALERT',
                message: 'Added blog!',
                severity: 'success'
            });
            dispatchInfo({ type: 'ADD_BLOG', blog: blog });
        },
        [dispatchAlert, dispatchInfo]
    );

    const addBlogHandler = React.useCallback(
        async (e: FormType) => {
            e.preventDefault();
            const result = await fetchHandler({
                data: {
                    member_guid: session.MemberGuid,
                    session_guid: session.SessionGuid,
                    data: blog
                }
            });
            result.success
                ? successHandler(result.data)
                : errorHandler(result.msg);
            dispatchAlert({ type: 'OPEN' });
        },
        [
            fetchHandler,
            session.MemberGuid,
            session.SessionGuid,
            blog,
            errorHandler,
            successHandler,
            dispatchAlert
        ]
    );

    // const validImageTypes = React.useMemo(() => ['image/jpeg', 'image/png'], []);

    // const selectFileHandler = React.useCallback(
    //     (e: React.ChangeEvent<HTMLInputElement> | any) => {
    //         if (!validImageTypes.includes(e.target.files[0].type)) {
    //             setError('Select a valid Image. (jpeg/png)');
    //         } else if (totalSize + e.target.files[0].size > 5000000) {
    //             setError('Exceeded maximum file size of 5mb.');
    //         } else {
    //             setError(null);
    //             setTotalSize(
    //                 prevTotalSize => prevTotalSize + e.target.files[0].size
    //             );
    //             setSelectedFiles(e.target.files[0]);
    //             // setSelectedFiles(prevSelectedFiles => [
    //             //   ...prevSelectedFiles,
    //             //   e.target.files[0]
    //             // ]);
    //             setSelectedFilePreviews(prevSelectedFilePreview => [
    //                 ...prevSelectedFilePreview,
    //                 URL.createObjectURL(e.target.files[0])
    //             ]);
    //         }
    //     },
    //     [totalSize, validImageTypes]
    // );

    return (
        <Form onSubmit={addBlogHandler}>
            <Alert closeHandler={closeAlert} {...alert} />
            <Field
                name='Title'
                onChange={onChangeHandler('Title')}
                sm={4}
                autoFocus
            />
            <Field name='Link' onChange={onChangeHandler('Link')} sm={4} />
            <Field
                name='DatePosted'
                label='Date Posted'
                type='date'
                InputLabelProps={{ shrink: true }}
                onChange={onChangeHandler('DatePosted')}
                sm={4}
            />
            <Field name='CoverImage' onChange={onChangeHandler('CoverImage')} />
            <Field
                name='Description'
                onChange={onChangeHandler('Description')}
                multiline
            />
            <Field
                name='ReadMore'
                label='Read More'
                onChange={onChangeHandler('ReadMore')}
                optional
                multiline
            />
            <ActionButton title='Add Blog' loading={loading} grid />
        </Form>
    );
});
